import DialogActions from '@material-ui/core/DialogActions'
import styled from 'styled-components'
import DialogContent from '@material-ui/core/DialogContent'
import SingleUseCreditCardForm from 'lib/stripe/SingleUseCreditCardForm'
import {useToggleArray} from 'lib/toggle'
import Button from 'lib/ui/Button'
import ErrorAlert from 'lib/ui/alerts/ErrorAlert'
import {usePayForTransaction} from 'obvio/Billing/TransactionSection/TransactionRow/PayDialog/SavedCardConfirmation'
import React, {useState} from 'react'
import {Title} from 'lib/ui/typography'
import {Transaction} from 'obvio/Billing/TransactionSection/list-transactions'
import {useBillingTransactionOrPassthrough} from 'obvio/Billing/BillingTransactionProvider'

export default function OtherCardForm(props: {
  transaction: Transaction
  onSuccess: () => void
  onCancel: () => void
}) {
  const {transaction, onSuccess, onCancel} = props
  const [processing, toggleProcessing] = useToggleArray()
  const {isTransactionPending} = useBillingTransactionOrPassthrough()
  const actionDisabled = isTransactionPending || processing
  const [error, setError] = useState<string | null>(null)
  const clearError = () => setError(null)
  const payForTransaction = usePayForTransaction(transaction)

  const completePayment = async (paymentMethodId: string) => {
    if (actionDisabled) {
      return
    }

    toggleProcessing()

    try {
      await payForTransaction(paymentMethodId)
      onSuccess()
    } catch (e: any) {
      setError(e.message)
      toggleProcessing()
      throw e
    }
  }

  return (
    <StyledDialogContent>
      <Title mt={2} mb={5}>
        Use a Different Card!
      </Title>
      <ErrorAlert onClose={clearError}>{error}</ErrorAlert>
      <SingleUseCreditCardForm
        disabled={actionDisabled}
        submitLabel="Pay"
        onSuccess={completePayment}
      />
      <DialogActions>
        <Button
          onClick={onCancel}
          aria-label="cancel different card"
          fullWidth
          disabled={actionDisabled}
        >
          Cancel
        </Button>
      </DialogActions>
    </StyledDialogContent>
  )
}

const StyledDialogContent = styled(DialogContent)`
  max-width: 450px;
`
